import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { thumbnailOverflowWrapper } from '../../../Thumbnail/Thumbnail.tokens';
import { type CardSizes } from '../types';

export const Wrapper = styled.div<{ $shadow?: boolean; $disabled?: boolean }>`
    ${thumbnailOverflowWrapper(6)};
    width: 100%;
    aspect-ratio: 1 / 1;
    background-color: rgb(0, 0, 0, 0.15);

    &:hover {
        cursor: ${({ $disabled }) => ($disabled ? 'auto' : 'pointer')};
    }

    ${({ $shadow }) =>
        $shadow &&
        css`
            box-shadow: 0 5px 7px #00000082;
        `}
`;

export const Rarity = styled(motion.div)<{ $cardSize?: CardSizes }>`
    background: rgba(9, 7, 25, 0.5);
    border-radius: 100px;

    height: 24px;
    padding: 0 8px;

    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1;

    display: flex;
    align-items: center;

    font-weight: 700;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: -0.02em;

    pointer-events: none;

    ${({ $cardSize }) => {
        if ($cardSize === 'small') {
            return css`
                top: 4px;
                left: 4px;

                font-size: 10px;
                height: 22px;
            `;
        }
    }}
`;

export const RarityText = styled.div`
    background: linear-gradient(94.36deg, #ffcf53 6.76%, #ff8a00 67.4%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
`;
